<template>
  <!-- 项目拆分 -->
  <div>
    <div class="ti d-flex">
      <div class="d-flex-left">
        <erp-tree @node-click="nodeClick"></erp-tree>
      </div>
      <div class="d-flex-right">
        <el-button @click="dataSplit">保存提交拆分</el-button>
        <el-button @click="del()">全部删除</el-button>
        <el-button @click="selects(1)">查询</el-button>
        <!-- 查询条件 -->
        <div style="width: 99%;">
          <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
            <el-descriptions-item label="房产">
              {{data.house}}
            </el-descriptions-item>
            <el-descriptions-item label="">

            </el-descriptions-item>
            <el-descriptions-item label="类型">
              <el-radio v-model="data.state" label="1">未处理</el-radio>
              <el-radio v-model="data.state" label="2">处理中</el-radio>
              <el-radio v-model="data.state" label="3">已处理</el-radio>
              <el-radio v-model="data.state" label="4">失败</el-radio>
            </el-descriptions-item>
            <el-descriptions-item label="查看方式">
              <el-radio v-model="data.radio2" label="1">汇总</el-radio>
              <el-radio v-model="data.radio2" label="2">明细</el-radio>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <!-- 调整 -->
        <div style="width: 99%;">
          <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
            <el-descriptions-item label="原项目">
              {{data.pname}}
            </el-descriptions-item>
            <el-descriptions-item label="新项目">
              <el-select v-model="data.newpid" style="width: 80%" clearable filterable  size="mini" placeholder="新项目">
                  <el-option
                    v-for="item in plists"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
              </el-select>
              <el-button size="mini" @click="charge">确定更改</el-button>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div style="width: 99%; margin-top: 10px;">
          <span style="color: red;" v-if="loading_dade==2">加载中...</span>
          <span style="color: blue;" v-else>加载完成</span>
          <div>
            <el-table ref="multipleTable" height="50vh" :data="orderData" border style="width: 100%" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55" > </el-table-column>
              <el-table-column prop="number" label="批次号" width="200"></el-table-column>
              <el-table-column prop="ancestor_name" label="房产"></el-table-column>
              <el-table-column prop="name" label="原项目" width="200"></el-table-column>
              <el-table-column prop="pname" label="更换到新项目" width="200"></el-table-column>
              <el-table-column prop="state" label="状态" width="150"></el-table-column>
              <el-table-column prop="date" label="添加时间" width="150"></el-table-column>
            </el-table>
          </div>
          <div class="pages">
            <el-pagination @size-change="selects_size"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[20,50,100,200,300,400,500]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        type:false,
        orderData:[],
        page:1,
        pageSize:20,
        total:0,
        chargeitems:[],
        loading_dade:1,
        data:{
          radio2:'2',
          pname:'',
          pid:'',
          house:'',
          state:'1',
          newpid:'',
        },
        plists:[],
      }
    },
    created(){
      this.plist();
    },
    components: {
      "erp-tree": () => import('../Common/erp-tree-adiust.vue'),
    },
    methods: {
       plist(){
         let data = {}
         this.$myhttp.post('admin/Split/pid',data,{
           'Content-Type': 'application/x-www-form-urlencoded'
           }).then(backdata=>{ // 异步执行成功后
          this.plists = backdata.data.data;
         },err=>{

         });
       },
       //确定拆分
       dataSplit(){
        this.$confirm('确定操作吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ERP.showLoading()
          let data = {'data':this.data}
          this.$myhttp.post('admin/Split/dataSplit',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
            ERP.hideLoading()
            if(backdata.data.code == 201){

              this.$confirm(''+backdata.data.message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {

              })

              return false;
            }
            this.$Message.success(backdata.data.message);
            this.selects(this.page);
          },err=>{
            ERP.hideLoading()
            this.$Message.error('请求异常!');
          });
        })
       },
       //删除
       del(){
        this.$confirm('确定操作吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ERP.showLoading()
          let data = {'data':this.data}
          this.$myhttp.post('admin/Split/del',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
            ERP.hideLoading()
            if(backdata.data.code == 201){
              this.$Message.error(backdata.data.message);
              return false;
            }
            this.$Message.success('操作成功!');
            this.selects(this.page);
          },err=>{
            ERP.hideLoading()
            this.$Message.error('请求异常!');
          });
        })
       },
       //确定更改
       charge(){
        let data = {'data':this.data}
        ERP.showLoading()
        this.$myhttp.post('admin/Split/update',data,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{
            ERP.hideLoading()
            if(backdata.data.code == 201){
              this.$Message.error(backdata.data.message);
              return false;
            }
            this.selects(this.page);
            this.$Message.success('操作成功!');
        },err=>{
          ERP.hideLoading()
          this.$Message.error('请求异常!');
        });
       },
       handleSelectionChange(val){
        this.order = val;
       },
       handleCurrentChange(e){
         this.page = e;//第几页
         this.selects(this.page);
       },
       selects_size(e){
         this.pageSize = e;
         this.selects(this.page);
       },
       // 查询
       selects(e){
         if(this.pid == ''){
           this.$Message.error('点击左边树选择项目');
           return false;
         }
         if(e){
           this.page = e;
         }
         this.loading_dade = 2;
         let data = {'data':this.data,'page':this.page,'pageSize':this.pageSize}
         this.$myhttp.post('admin/Split/houseList',data,{
           'Content-Type': 'application/x-www-form-urlencoded'
           }).then(backdata=>{ // 异步执行成功后
             this.loading_dade = 1;
             if(backdata.data.code == 201){
               this.$Message.error(backdata.data.message);
               return false;
             }
             this.orderData = backdata.data.data;
             this.total = backdata.data.count;
         },err=>{
           this.loading_dade = 1;
           this.$Message.error('请求异常!');
         });
       },
      //点击树
      nodeClick(data){
        this.data.pid = data.tree[0].pindex_id;
        let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
        this.data.house=tree_str;
        this.data.pname = data.tree[0].name;

        if(this.data.house == this.data.pname){
          this.selects(this.page);
          return false;
        }
        this.$confirm('确定添加吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ERP.showLoading()
          let data = {'data':this.data,'order':this.order}
          this.$myhttp.post('admin/Split/add',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
            ERP.hideLoading()
            this.selects(this.page);
            this.$confirm(''+backdata.data.message, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {

            })
          },err=>{
            ERP.hideLoading()
            this.$Message.error('请求异常!');
          });
        })

      },
    }
  }
</script>

<style>
  .ti{
    background-color: white;
  }
  .d-flex {
    display: flex;
  }
  .d-flex-left {
    margin-right: 10px;
    border-right: 1px solid #eee;
    padding-right: 10px;
    width: 250px;

  }
  .d-flex-right {
    flex: 1;
    overflow-x:hidden;
  }
  .text2{
    color: rgb(250, 248, 248);
  }
</style>

<style lang="scss" scoped>
  .right-main {
    display: flex;
    // overflow: auto;//体内容的滚动条
    flex: 1;
    background: #fff;
  }
</style>




// WEBPACK FOOTER //
// src/components/Admin/Project/Split.vue